import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { MdKeyboardArrowRight } from "react-icons/md";
import SummaryApi from "../../common";

const AllSection = () => {
  const [sections, setSections] = useState([]); // State to store sections
  const [loading, setLoading] = useState(true); // State to track loading status
  const [error, setError] = useState(null); // State to track errors

  // Fetch the sections data from the API
  useEffect(() => {
    const fetchSections = async () => {
      try {
        const response = await fetch(SummaryApi.getAllSections.url);
        const contentType = response.headers.get("Content-Type");
        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }
        if (!contentType || !contentType.includes("application/json")) {
          throw new Error("Expected JSON, but got " + contentType);
        }
        const data = await response.json();
        setSections(data.data); // Update state with the fetched data
      } catch (err) {
        setError(err.message); // Set the error message if fetch fails
      } finally {
        setLoading(false); // Set loading to false after the fetch is complete
      }
    };

    fetchSections();
  }, []);

  // Helper function to format date
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toISOString().split("T")[0]; // Extracts the date part (yyyy-mm-dd)
  };

  return (
    <div className="">
      <h1 className="text-2xl sm:text-3xl md:text-3xl lg:text-3xl xl:text-3xl font-semibold mb-4 sm:mb-5 md:mb-6 text-center sm:text-left">
        Sections
      </h1>

      <nav className="text-gray-600 mb-4">
        <ol className="flex flex-wrap items-center space-x-2 text-sm sm:text-base md:text-lg lg:text-xl xl:text-xl">
          <li>
            <Link to="/dashboard" className="hover:text-[#ffa404]">
              Home
            </Link>
          </li>
          <li className="text-[#ffa404]">
            <MdKeyboardArrowRight size={25} />
          </li>
          <li className="text-[#ffa404]">
            <Link to="/AllSection" className="hover:text-[#ffa404]">
              All Sections
            </Link>
          </li>
        </ol>
      </nav>

      <div className="bg-white shadow-md rounded-lg p-6 mt-6 h-[70vh] sm:h-[60vh] md:h-[60vh] lg:h-[70vh] xl:h-[80vh]">
        <h2 className="text-xl font-semibold text-gray-800 mb-4 text-center sm:text-left">
          All Section Schedules
        </h2>

        <div className="overflow-x-auto">
          {/* Handle loading and error */}
          {loading && <div>Loading...</div>}
          {error && <div className="text-red-500">{error}</div>}

          <table className="table-auto w-full border border-gray-300 border-collapse">
            <thead>
              <tr className="border-b border-gray-300">
                <th className="py-2 px-4 text-left text-gray-600">S.no</th>
                <th className="py-2 px-4 text-left text-gray-600">Section Name</th>
                <th className="py-2 px-4 text-left text-gray-600">Is Active</th>
                <th className="py-2 px-4 text-left text-gray-600">Created Date</th>
              </tr>
            </thead>
            <tbody>
              {/* Map through the sections data */}
              {sections.length > 0 ? (
                sections.map((section, index) => (
                  <tr
                    key={section.section_id}
                    className="border-b border-gray-300 even:bg-gray-100 odd:bg-white hover:bg-gray-200"
                  >
                    <td className="py-2 px-4">{index + 1}</td> {/* Display serial number */}
                    <td className="py-2 px-4">{section.section_name}</td> {/* Display section_name */}
                    <td className="py-2 px-4">
                      <span
                        className={`${
                          section.is_active === "1" ? "text-green-500" : "text-red-500"
                        } font-semibold`}
                      >
                        {section.is_active === "1" ? "Active" : "Inactive"}
                      </span>
                    </td> {/* Display is_active with color */}
                    <td className="py-2 px-4">
                      {formatDate(section.created_date)}
                    </td> {/* Display formatted created_date */}
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="4" className="text-center py-4">
                    No data available
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default AllSection;
